export interface ButtonVariantNameProps {
  default: string;
  textColorSecondary: string;
}

export enum BUTTON_VARIANTS {
  default = 'default',
  textColorSecondary = 'textColorSecondary',
}
